import { apiFetch } from "../../shared/helper/apiFetch";
import { helperServices } from "../../shared/helper";

const basePath = "/api/packageservices";

// -------------------- Headers --------------------
function buildHeaders(contentType = "application/json") {
  const accessToken = helperServices.getAuthorization() || "";

  return {
    Accept: contentType,
    "Content-Type": contentType,
    Authorization: accessToken,
  };
}

// -------------------- Get all services --------------------
export const getAllPackageServices = () => {
  return apiFetch(basePath, {
    method: "GET",
    headers: buildHeaders(),
  });
};

// -------------------- Get services by package --------------------
export const getServicesByPackage = (packageId) => {
  return apiFetch(`/api/v1/packageService?visitId=${packageId}`, {
    method: "GET",
    headers: buildHeaders(),
  });
};

// -------------------- Create service --------------------
export const createPackageService = (payload) => {
  return apiFetch(basePath, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(payload),
  });
};



// -------------------- Update service --------------------
export const updatePackageService = (id, payload) => {
  return apiFetch(`${basePath}/${id}`, {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(payload),
  });
};

// -------------------- Delete service --------------------
export const deletePackageService = (id) => {
  return apiFetch(`${basePath}/${id}`, {
    method: "DELETE",
    headers: buildHeaders(),
  });
};

// -------------------- DEFAULT EXPORT --------------------
const packageService = {
  getAllPackageServices,
  getServicesByPackage,
  createPackageService,
  updatePackageService,
  deletePackageService,
};

export default packageService;